// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrideFlag_wrapper__MALYf","column":"PrideFlag_column__BFYdb","oscillate":"PrideFlag_oscillate___fASU","pixel":"PrideFlag_pixel__tHQHG"};